@if (showChatButton())
{
    <button
        mat-fab
        aria-label="Open chat"
        class="fixed bottom-5 right-5 z-90"
        (click)="chatDrawer.toggle()"
        >
        <mat-icon
            class="text-white icon-size-5"
            svgIcon="mat_solid:forum"
        >
        </mat-icon>
    </button>
}

<fuse-drawer
    class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100"
    fixed
    [mode]="'over'"
    [name]="'chatDrawer'"
    [position]="'right'"
    #chatDrawer
>
    <div class="relative bg-card flex w-full flex-col overflow-auto h-full">
        <button
            mat-icon-button
            class="absolute top-2 right-2 bg-white z-10"
            (click)="chatDrawer.close()"
        >
            <mat-icon
                class="text-current"
                svgIcon="mat_solid:close"
            >
            </mat-icon>
        </button>

        <!-- Contenido del chat -->
        @if (showChatList())
        {
            <!-- Lista de conversaciones -->
            <div class="flex flex-col h-full">
                <div class="flex items-center justify-between mb-4 mx-4 mt-4">
                    <h2 class="text-xl font-medium">Mis conversaciones</h2>
                </div>

                <!-- Loading indicator -->
                @if (isLoading())
                {
                    <div class="flex justify-center items-center p-4">
                        <mat-spinner diameter="24"></mat-spinner>
                    </div>
                }

                <!-- Lista de conversaciones -->
                <div class="flex-1 overflow-y-auto p-4" (scroll)="handlerScroll($event)">
                    @if (conversations() && conversations().length > 0)
                    {
                        @for (conversation of conversations(); track conversation.id)
                        {
                            <div
                                class="p-4 mb-2 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                (click)="selectConversation(conversation)">
                                <div class="font-medium line-clamp-1">{{ conversation.title }}</div>
                                <div class="text-sm text-gray-500">{{ conversation.createdAt | date:'short' }}</div>
                            </div>
                        }
                    }
                    @else
                    {
                        @if (!isLoading())
                        {
                            <div class="flex flex-col items-center justify-center h-full text-center p-6">
                                <p class="mb-6 text-gray-500">No tienes conversaciones aún</p>
                            </div>
                        }
                    }
                </div>

                <!-- Botón para nuevo chat -->
                <div class="p-4 border-t">
                    <button
                        mat-flat-button
                        color="primary"
                        class="w-full"
                        (click)="startNewChat()">
                        <mat-icon>add</mat-icon>
                        <span>Nueva conversación</span>
                    </button>
                </div>
            </div>
        }
        @else
        {
            <!-- Vista de chat individual -->
            <div class="flex flex-col h-full">
                <!-- Header -->
                <div class="flex items-center justify-between mb-4 mx-4 mt-4">
                    <div class="flex items-center">
                        <button
                            mat-icon-button
                            (click)="backToConversationList()">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        <h2 class="text-xl font-medium ml-2">
                            @if (activeConversation())
                            {
                                {{ activeConversation().title }}
                            }
                            @else
                            {
                                Nuevo chat
                            }
                        </h2>
                    </div>
                </div>

                <!-- Componente de chat (mantiene el mismo que ya usabas) -->
                <div class="flex-1 overflow-hidden">
                    <au-ai-chat
                        [messages]="messages()"
                        [currentUser]="currentUser()"
                        [showSpinner]="isLoading()"
                        (sendMessage)="
                            actionService.action({
                                id          : 'ama::generalChatConversation.list.sendMessage',
                                isViewAction: false,
                                meta: {
                                    messageInput: $event,
                                }
                            })
                        "
                        (scroll)="handlerScroll($event)"
                        (navigateToNote)="onNavigateToNote($event)"
                    >
                    </au-ai-chat>
                </div>
            </div>
        }
    </div>
</fuse-drawer>
